import React from 'react';
import { Gallery } from 'components/gallery/Gallery';
import { GalleryItem } from 'components/gallery/GalleryItem';

export const Component = () => {
  return (
    <Gallery title="Gallery title" isSlice>
      <GalleryItem
        title="Dark Grey on White"
        image={{ url: 'https://picsum.photos/id/1021/1920/1080', width: 1920, height: 1080 }}
        caption="Image caption/description"
      />
      <GalleryItem
        title="Yellow on Dark Grey"
        image={{ url: 'https://picsum.photos/id/942/1920/1080', width: 1920, height: 1080 }}
      />
    </Gallery>
  );
};
